export default "__VITE_ASSET__Rk_ZIxg2__"